(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["charminside-growth-guide"] && !Shopify.designMode) return;
  try {
    (function(){
 const view=document.getElementById('ci-growth-guide');if(!view)return;
 const page=view.closest('.ci-page');
 function sync(){const open=location.hash==='#ci-growth-guide';view.hidden=!open;page.classList.toggle('ci-reading-guide',['#ci-photo-guide','#ci-social-guide','#ci-growth-guide'].includes(location.hash));if(open)window.scrollTo(0,0)}
 addEventListener('hashchange',sync);sync();
})();
(function(){

  const root = document.getElementById("charm-ai-learning-guide");
  if(!root || root.dataset.loaded === "1") return;
  root.dataset.loaded = "1";

  const questions = [
    {
      category:"TECHNIKA",
      text:"Ar gali ne tik atlikti procedūrą, bet ir aiškiai paaiškinti, kodėl vienoje situacijoje renkiesi vieną sprendimą, o ne kitą?"
    },
    {
      category:"KONSULTACIJA",
      text:"Ar moki išsiaiškinti tikrąjį klientės norą, o ne tik paklausti „ko norėtumėte?“"
    },
    {
      category:"PARDAVIMAS",
      text:"Ar moki rekomenduoti papildomą paslaugą ar produktą taip, kad nesijaustum pardavinėjanti?"
    },
    {
      category:"KAINODARA",
      text:"Ar žinai, kiek realiai uždirbi iš vienos procedūros?"
    },
    {
      category:"SOCIAL MEDIA",
      text:"Ar supranti, kodėl vienas tavo turinys atveda klientę, o kitas tik surenka peržiūras?"
    },
    {
      category:"FOTOGRAFIJA",
      text:"Ar gali sąmoningai pakartoti gerą rezultatų fotografiją skirtingomis apšvietimo sąlygomis?"
    },
    {
      category:"AI / TECHNOLOGIJOS",
      text:"Ar AI naudoji tik tekstams, ar ir mokymuisi, role-play, analizei bei sprendimų treniruotėms?"
    },
    {
      category:"VERSLAS",
      text:"Ar žinai, ką turėtum pagerinti, kad po metų uždirbtum daugiau nedirbdama daugiau valandų?"
    }
  ];

  let questionIndex = 0;
  const scores = {};

  const category = root.querySelector("#cag-category");
  const question = root.querySelector("#cag-question");
  const answers = root.querySelector("#cag-answers");
  const counter = root.querySelector("#cag-counter");
  const progress = root.querySelector("#cag-progress-bar");

  function renderQuestion(){
    const current = questions[questionIndex];

    category.textContent = current.category;
    question.textContent = current.text;
    counter.textContent = (questionIndex + 1) + " / " + questions.length;
    progress.style.width = (((questionIndex + 1) / questions.length) * 100) + "%";

    answers.innerHTML = "";

    [
      ["Taip, tvirtai",9],
      ["Kartais / iš dalies",5],
      ["Ne / nežinau",2]
    ].forEach(function(option){

      const button = document.createElement("button");
      button.type = "button";
      button.className = "cag-btn";
      button.textContent = option[0];

      button.addEventListener("click",function(){
        scores[current.category] = option[1];
        questionIndex++;

        if(questionIndex < questions.length){
          renderQuestion();
        }else{
          showResults();
        }
      });

      answers.appendChild(button);
    });
  }

  function showResults(){

    root.querySelector("#cag-assessment").classList.add("cag-hidden");

    const results = root.querySelector("#cag-results");
    results.classList.remove("cag-hidden");

    const map = root.querySelector("#cag-map");
    map.innerHTML = "";

    Object.keys(scores).forEach(function(key){

      const value = scores[key];
      const row = document.createElement("div");

      row.innerHTML =
        '<div class="cag-map-head">' +
        '<span>' + key + '</span>' +
        '<span>' + value + '/10</span>' +
        '</div>' +
        '<div class="cag-bar"><span style="width:' +
        (value * 10) +
        '%"></span></div>';

      map.appendChild(row);
    });

    const lowest = Object.entries(scores).sort(function(a,b){
      return a[1] - b[1];
    })[0];

    root.querySelector("#cag-focus-name").textContent = lowest[0];

    results.scrollIntoView({
      behavior:"smooth",
      block:"start"
    });
  }

  renderQuestion();


  root.querySelector("#cag-start-training").addEventListener("click",function(){

    const training = root.querySelector("#cag-training");
    training.classList.remove("cag-hidden");

    training.scrollIntoView({
      behavior:"smooth",
      block:"start"
    });
  });


  const scenarios = {

    sales:{
      label:"SALES ROLE-PLAY",
      text:"Klientė sako: „Dažymo nenoriu, man užtenka laminavimo.“ Tu matai, kad jos plaukeliai labai šviesūs ir be dažymo rezultatas bus gerokai silpnesnis. Ką jai pasakai?"
    },

    pricing:{
      label:"BUSINESS CASE",
      text:"Tavo populiariausia procedūra kainuoja 45 €. Kalendorius beveik pilnas, bet mėnesio gale pajamos vis tiek atrodo per mažos. Ką tikrintum prieš nuspręsdama kelti kainą?"
    },

    client:{
      label:"CLIENT PSYCHOLOGY",
      text:"Klientė po procedūros sako: „Man atrodo per tamsu“, nors prieš procedūrą patvirtino norimą intensyvumą. Koks tavo pirmas sakinys?"
    },

    business:{
      label:"BUSINESS GYM",
      text:"Turi daug darbo, bet nenori dirbti daugiau valandų. Išvardyk tris būdus, kaip galėtum auginti pajamas nedidindama vizitų skaičiaus."
    }

  };


  root.querySelectorAll(".cag-scenario").forEach(function(button){

    button.addEventListener("click",function(){

      root.querySelectorAll(".cag-scenario").forEach(function(item){
        item.classList.remove("active");
      });

      button.classList.add("active");

      const data = scenarios[button.dataset.scenario];

      root.querySelector("#cag-scenario-label").textContent = data.label;
      root.querySelector("#cag-scenario-text").textContent = data.text;
      root.querySelector("#cag-response").value = "";
      root.querySelector("#cag-feedback").classList.add("cag-hidden");
      root.querySelector("#cag-training-box").classList.remove("cag-hidden");
    });

  });


  root.querySelector("#cag-analyse").addEventListener("click",function(){

    const response = root.querySelector("#cag-response").value.trim();
    const feedback = root.querySelector("#cag-feedback");

    feedback.classList.remove("cag-hidden");

    if(response.length < 15){

      feedback.innerHTML =
        "<strong>Pabandyk atsakyti konkrečiau.</strong>" +
        "<br><br>Mokymasis prasideda nuo tavo sprendimo. " +
        "Parašyk bent 1–2 sakinius, ką realiai darytum.";

      return;
    }

    feedback.innerHTML =
      '<div class="cag-question-type">COACH MODE</div>' +
      '<p><strong>AI neturėtų tau tiesiog parašyti „geresnio atsakymo“.</strong></p>' +
      '<p>Jis turėtų išnarplioti tavo argumentą: kas jame stipru, ' +
      'kokią prielaidą padarei, ko nepaklausei ir kokį klausimą galėjai užduoti geriau.</p>' +
      '<p><strong>Tada — TRY AGAIN.</strong> Gauni sudėtingesnę tos pačios situacijos versiją.</p>';
  });


  const levelTexts = {
    1:"„O dažymas prie laminavimo tikrai reikalingas?“",
    2:"„Nenoriu. Man ir taip jau brangu.“",
    3:"„Kitoje vietoje laminavimas su dažymu kainuoja tiek, kiek pas jus vien laminavimas.“",
    4:"„Ačiū, pagalvosiu.“"
  };

  root.querySelectorAll(".cag-level").forEach(function(button){

    button.addEventListener("click",function(){

      root.querySelector("#cag-level-text").textContent =
        levelTexts[button.dataset.level];
    });

  });


  let selectedSkills = [];
  let learningStyle = "";

  root.querySelectorAll("#cag-skills .cag-chip").forEach(function(button){

    button.addEventListener("click",function(){

      const skill = button.textContent;

      if(selectedSkills.indexOf(skill) !== -1){

        selectedSkills = selectedSkills.filter(function(item){
          return item !== skill;
        });

        button.classList.remove("active");

      }else if(selectedSkills.length < 3){

        selectedSkills.push(skill);
        button.classList.add("active");

      }
    });

  });


  root.querySelectorAll("#cag-learning-style .cag-chip").forEach(function(button){

    button.addEventListener("click",function(){

      root.querySelectorAll("#cag-learning-style .cag-chip").forEach(function(item){
        item.classList.remove("active");
      });

      button.classList.add("active");
      learningStyle = button.textContent;
    });

  });


  root.querySelector("#cag-build").addEventListener("click",function(){

    const plan = root.querySelector("#cag-plan");

    plan.classList.remove("cag-hidden");

    if(selectedSkills.length === 0){

      plan.innerHTML =
        "<strong>Pirmiausia pasirink bent vieną kryptį, kurią nori sustiprinti.</strong>";

      return;
    }

    const time = root.querySelector("#cag-time").value;

    plan.innerHTML =
      '<div class="cag-plan-top">TAVO 2027 LEARNING SYSTEM</div>' +
      '<h3>' + selectedSkills.join(" × ") + '</h3>' +

      '<div class="cag-plan-step">' +
      '<strong>RITMAS</strong>' +
      '<span>' + time + '</span>' +
      '</div>' +

      '<div class="cag-plan-step">' +
      '<strong>DIAGNOSE</strong>' +
      '<span>Pradėk ne nuo teorijos. Paprašyk AI pirmiausia patikrinti, ką jau moki.</span>' +
      '</div>' +

      '<div class="cag-plan-step">' +
      '<strong>LEARN</strong>' +
      '<span>Mokykis tik to, ko nesupratai — ne visos temos nuo pradžių.</span>' +
      '</div>' +

      '<div class="cag-plan-step">' +
      '<strong>PRACTICE</strong>' +
      '<span>Naudok role-play, realius beauty case ir savo verslo situacijas.</span>' +
      '</div>' +

      '<div class="cag-plan-step">' +
      '<strong>USE</strong>' +
      '<span>Tą pačią savaitę pritaikyk bent vieną naują dalyką savo darbe.</span>' +
      '</div>' +

      '<div class="cag-plan-step">' +
      '<strong>PROVE</strong>' +
      '<span>Po kelių dienų paprašyk AI patikrinti tave iš naujo be užuominų.</span>' +
      '</div>' +

      (learningStyle
        ? '<div class="cag-plan-step"><strong>FORMATAS</strong><span>' +
          learningStyle +
          '</span></div>'
        : '') +

      '<p style="margin:25px 0 0;font-size:17px;"><strong>' +
      'Tikslas: ne „baigti kursą“. Tikslas — pakeisti tai, ką realiai sugebi padaryti.' +
      '</strong></p>';

    plan.scrollIntoView({
      behavior:"smooth",
      block:"nearest"
    });

  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charminside-photo-guide"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ci-photo').forEach(root=>{
 const page=root.closest('.ci-page');
 const syncGuide=()=>{const open=location.hash==='#ci-photo-guide';root.hidden=!open;page.classList.toggle('ci-reading-guide',['#ci-photo-guide','#ci-social-guide','#ci-growth-guide'].includes(location.hash));if(open)window.scrollTo(0,0)};
 window.addEventListener('hashchange',syncGuide);syncGuide();
 const storageKey='charm_meistrams_photo_guide_v1';
 const state={light:'',control:'',mode:'Neutral',kelvin:'5200',power:'60',distance:'80',phone:'',issue:'',lights:[],checklist:[]};
 try{Object.assign(state,JSON.parse(localStorage.getItem(storageKey)||'{}'))}catch(e){}
 const advice={light:{'Ring lempa':'Pakelk šiek tiek aukščiau akių lygio ir stebėk, ar antakyje lieka matoma plaukelių tekstūra.','Video / LED lempa':'Kiekvienai BEFORE / AFTER serijai išlaikyk tą patį aukštį, kampą ir atstumą.','Dvi video lempos':'Abi nustatyk į tą patį spalvos režimą; antra gali būti silpnesnė.'},control:{'Tik ryškumą':'Kontroliuok aplinkos šviesą ir visada fotografuok toje pačioje vietoje.','Nieko nereguliuoju':'Kontroliuok aplinkos šviesą, ekspoziciją ir fotografavimo vietą.','Warm':'Warm gali sustiprinti gelsvus ir varinius tonus.','Neutral':'Neutral – geras pradinis taškas, kai nori mažiau keisti tikrąją antakių spalvą.','Cool':'Cool gali atšaldyti rudą spalvą ir odą.'},phone:{'iPhone':'Naudok 1× kamerą. Paspausk ir palaikyk ties veidu, kol atsiras AE/AF LOCK; ekspoziciją koreguok taip, kad matytųsi plaukeliai.','Samsung':'Naudok 1× kamerą. Jei yra PRO režimas, užfiksuok WB (white balance) ir ekspoziciją BEFORE / AFTER serijai.','Kitas Android':'Naudok 1× kamerą. Jei yra PRO / MANUAL režimas, ieškok WB ir EV kontrolės; išjunk Beauty / Retouch.'},issue:{'Per ryža / šilta':'Išjunk šiltą aplinkos apšvietimą; palygink Neutral režimą arba maždaug 5000–5500 K.','Per pilka / šalta':'Palygink Cool režimą su Neutral ir patikrink white balance.','Antakis atrodo juodas':'Patikrink ekspoziciją, lempos galią ir atstumą. Svarbu matyti atskirus plaukelius.','Oda geltona':'Pirmiausia patikrink, ar kartu su darbo lempa nedega šiltos lubų ar veidrodžio lempos.','BEFORE ≠ AFTER':'Kartok tą pačią lempą, režimą, atstumą, 1× kamerą, ekspoziciją, kampą ir klientės poziciją.'}};
 const pick=(group,value)=>{state[group]=value;save()};
 const save=()=>{try{localStorage.setItem(storageKey,JSON.stringify(state))}catch(e){}render()};
 const render=()=>{
  root.querySelectorAll('[data-choice]').forEach(group=>group.querySelectorAll('button').forEach(btn=>btn.setAttribute('aria-pressed',String(state[group.dataset.choice]===btn.textContent.trim()))));
  root.querySelector('[data-for=kelvin]').hidden=state.control!=='Rodo K / Kelvinus';
  root.querySelector('[data-for=mode]').hidden=state.control!=='Warm · Neutral · Cool';
  ['light','control','phone','issue'].forEach(k=>{const v=k==='control'&&state.control==='Warm · Neutral · Cool'?state.mode:state[k];root.querySelector('[data-advice='+k+']').textContent=advice[k][v]||''});
  root.querySelector('[data-advice=lights]').textContent=state.lights.length?'Pabandyk nufotografuoti palikusi tik pagrindinę darbo lempą ir palygink spalvą.':'Vienas kontroliuojamas šviesos šaltinis palengvina spalvos atkūrimą.';
  ['kelvin','power','distance'].forEach(k=>{root.querySelector('[name='+k+']').value=state[k];root.querySelector('[data-output='+k+']').textContent=state[k]+(k==='kelvin'?' K':k==='power'?'%':' cm')});
  ['light','phone'].forEach(k=>root.querySelector('[data-preset='+k+']').textContent=state[k]||'—');
  root.querySelector('[data-preset=mode]').textContent=state.control==='Rodo K / Kelvinus'?state.kelvin+' K':state.control==='Warm · Neutral · Cool'?state.mode:state.control||'—';
  ['power','distance'].forEach(k=>root.querySelector('[data-preset='+k+']').textContent=state[k]+(k==='power'?'%':' cm'));
  root.querySelectorAll('[data-group=lights] input').forEach(input=>input.checked=state.lights.includes(input.value));
  root.querySelectorAll('[data-group=checklist] input').forEach((input,i)=>input.checked=Boolean(state.checklist[i]));
  const done=state.checklist.filter(Boolean).length;root.querySelector('[data-progress]').textContent=done+' / 5'+(done===5?' · Paruošta fotografuoti':'');
 };
 root.querySelectorAll('[data-choice]').forEach(group=>group.addEventListener('click',event=>{const button=event.target.closest('button');if(button)pick(group.dataset.choice,button.textContent.trim())}));
 root.querySelectorAll('input[type=range]').forEach(input=>input.addEventListener('input',()=>pick(input.name,input.value)));
 root.querySelectorAll('[data-group=lights] input').forEach(input=>input.addEventListener('change',()=>{state.lights=Array.from(root.querySelectorAll('[data-group=lights] input:checked'),el=>el.value);save()}));
 root.querySelectorAll('[data-group=checklist] input').forEach((input,i)=>input.addEventListener('change',()=>{state.checklist[i]=input.checked;save()}));
 render();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charminside-social-guide"] && !Shopify.designMode) return;
  try {
    (function () {
  var view=document.getElementById('ci-social-guide');
  if(!view)return;
  var page=view.closest('.ci-page');
  function sync(){var open=location.hash==='#ci-social-guide';view.hidden=!open;page.classList.toggle('ci-reading-guide',['#ci-photo-guide','#ci-social-guide','#ci-growth-guide'].includes(location.hash));if(open)window.scrollTo(0,0)}
  window.addEventListener('hashchange',sync);sync();
})();
(function () {
  const root = document.getElementById("charm27");

  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";


  /* =========================
     SOCIAL CHECK
  ========================== */

  const questions = [
    {
      zone: "discovery",
      text: "Ar bent trečdalis tavo Reels suprantami žmogui, kuris tavęs visiškai neseka?"
    },
    {
      zone: "identity",
      text: "Ar turi 2–3 pasikartojančias rubrikas, kurias galėtum tęsti pusę metų?"
    },
    {
      zone: "proof",
      text: "Ar rodai ne tik rezultatą, bet ir kodėl priėmei konkretų profesinį sprendimą?"
    },
    {
      zone: "discovery",
      text: "Ar žinai, kurie įrašai atveda profile visits, sends ar realias užklausas?"
    },
    {
      zone: "relationship",
      text: "Ar komentarai ir klienčių klausimai reguliariai tampa nauju tavo turiniu?"
    },
    {
      zone: "identity",
      text: "Jei paslėptume vardą ir logo, ar žmogus galėtų atpažinti tavo turinį?"
    }
  ];

  const answers = new Array(questions.length).fill(null);

  const questionsWrap = root.querySelector("#charmQuestions");
  const progress = root.querySelector("#charmProgress");
  const auditResult = root.querySelector("#charmAuditResult");
  const finalResult = root.querySelector("#charmFinal");


  questions.forEach(function (question, index) {
    const item = document.createElement("div");
    item.className = "audit-question";

    const text = document.createElement("p");
    text.textContent = (index + 1) + ". " + question.text;

    const row = document.createElement("div");
    row.className = "button-row";

    ["Taip", "Ne"].forEach(function (label) {
      const button = document.createElement("button");
      button.type = "button";
      button.textContent = label;
      button.dataset.index = String(index);
      button.dataset.value = label === "Taip" ? "1" : "0";

      row.appendChild(button);
    });

    item.appendChild(text);
    item.appendChild(row);
    questionsWrap.appendChild(item);
  });


  questionsWrap.addEventListener("click", function (event) {
    const button = event.target.closest("button[data-index]");
    if (!button) return;

    const index = Number(button.dataset.index);
    const value = Number(button.dataset.value);

    answers[index] = value;

    button.parentElement.querySelectorAll("button").forEach(function (item) {
      item.classList.remove("selected");
    });

    button.classList.add("selected");

    const completed = answers.filter(function (value) {
      return value !== null;
    }).length;

    progress.textContent = completed + " / " + questions.length;

    if (completed === questions.length) {
      calculateResult();
    }
  });


  const zoneData = {
    discovery: {
      title: "DISCOVERY",
      description:
        "Tavo darbas gali būti stiprus, bet naujam žmogui dar trūksta aiškių įėjimų į tavo pasaulį.",
      plan: [
        "Sukurk 4 Reels, kurių pirmas sakinys prasideda nuo konkrečios klientės problemos.",
        "Pasirink 2 temas, su kuriomis nori būti siejama, ir kiekvieną per mėnesį išplėsk bent 3 skirtingais kampais.",
        "Kartą per savaitę tikrink ne likes, o profile visits, sends ir realias užklausas iš konkretaus turinio."
      ]
    },

    identity: {
      title: "IDENTITY",
      description:
        "Contento yra, bet dalis jo galėtų priklausyti bet kuriai kitai meistrei.",
      plan: [
        "Sukurk vieną aiškiai atpažįstamą rubriką ir per 30 dienų pakartok ją bent 4 kartus.",
        "Užrašyk 3 profesines nuomones, su kuriomis ne visi tavo srityje sutiktų, ir paversk jas turiniu.",
        "Pasirink vieną pateikimo principą, kurį sąmoningai kartosi: struktūrą, filmavimo būdą arba kalbėjimo formatą."
      ]
    },

    proof: {
      title: "PROOF",
      description:
        "Rezultatų gali būti daug, bet auditorijai reikia daugiau tavo sprendimų ir kompetencijos įrodymų.",
      plan: [
        "Vieną Before / After paversk pilnu mini case study: problema → sprendimas → rezultatas.",
        "Susisiek su 2 klientėmis po 3–4 savaičių ir parodyk realų follow-up rezultatą.",
        "Kartą per savaitę paaiškink profesinį sprendimą, kurio klientė pati nebūtų žinojusi priimti."
      ]
    },

    relationship: {
      title: "RELATIONSHIP",
      description:
        "Žmonės tave pamato, bet dar neišnaudoji jų klausimų ir reakcijų kaip savo turinio variklio.",
      plan: [
        "30 dienų išsisaugok kiekvieną pasikartojantį klausimą iš DM, komentarų ir pokalbių su klientėmis.",
        "Per mėnesį sukurk bent 4 turinio vienetus iš realių auditorijos klausimų.",
        "Kartą per savaitę Stories palik atvirą auditorijos reakcijai ir kitą dieną tęsk temą pagal tai, ką žmonės parašė."
      ]
    }
  };


  function calculateResult() {
    const misses = {
      discovery: 0,
      identity: 0,
      proof: 0,
      relationship: 0
    };

    answers.forEach(function (answer, index) {
      if (answer === 0) {
        misses[questions[index].zone] += 1;
      }
    });

    const priority = [
      "discovery",
      "identity",
      "proof",
      "relationship"
    ];

    priority.sort(function (a, b) {
      return misses[b] - misses[a];
    });

    const zone = priority[0];
    const result = zoneData[zone];

    auditResult.classList.add("show");
    auditResult.innerHTML =
      '<div class="result-label">PIRMINIS SIGNALAS</div>' +
      "<h3>" + result.title + "</h3>" +
      "<p>" + result.description + "</p>";

    renderFinal(result);
  }


  function renderFinal(result) {
    const items = result.plan.map(function (item, index) {
      return (
        '<div class="plan-item">' +
          '<div class="plan-number">0' + (index + 1) + "</div>" +
          "<div>" + item + "</div>" +
        "</div>"
      );
    }).join("");

    finalResult.innerHTML =
      '<div class="result-label">TAVO STIPRINTINA ZONA</div>' +
      '<div class="final-zone">' + result.title + "</div>" +
      '<p class="body">' + result.description + "</p>" +
      '<div class="plan">' +
        '<div class="result-label">30 DIENŲ EKSPERIMENTAS</div>' +
        items +
      "</div>";
  }


  /* =========================
     2025 → 2027
  ========================== */

  const comparisons = {
    before: {
      oldYear: "2025",
      oldType: "Before / After",
      oldCopy:
        "Fresh brows 🤎\nAntakių korekcija + dažymas.",

      newYear: "2027",
      newType: "Real client case",
      newCopy:
        "„Ji paprašė tamsiau. Aš pasirinkau šviesiau.“\nKą pamačiau konsultacijoje ir kodėl priėmiau tokį sprendimą.",

      why:
        "Rezultatas lieka. Bet dabar jis įrodo ne tik tai, kad moki atlikti procedūrą — jis parodo, kaip mąstai."
    },

    education: {
      oldYear: "2025",
      oldType: "Edukacija",
      oldCopy:
        "5 dalykai, kuriuos reikia žinoti prieš laminavimą.",

      newYear: "2027",
      newType: "First-hand expertise",
      newCopy:
        "„Per paskutines 30 klienčių šitą pačią klaidą pamačiau 11 kartų.“",

      why:
        "Bendra informacija lengvai nukopijuojama. Tavo darbo metu sukauptas pastebėjimas — ne."
    },

    stories: {
      oldYear: "2025",
      oldType: "Stories",
      oldCopy:
        "Labas rytas 🤍 Šiandien pilna diena klienčių.",

      newYear: "2027",
      newType: "Real-time thinking",
      newCopy:
        "„Stop. Pažiūrėkit į šitą vietą. Dėl jos dabar keičiu tai, ką buvau suplanavusi.“",

      why:
        "Stories tampa ne dienoraščiu apie tai, kad dirbi, o vieta, kur žmogus mato tavo profesinį mąstymą realiu laiku."
    },

    trend: {
      oldYear: "2025",
      oldType: "Trend",
      oldCopy:
        "Populiarus audio + tavo darbo video.",

      newYear: "2027",
      newType: "Trend through your lens",
      newCopy:
        "Naudoji trendą tik tada, kai jis leidžia pasakyti kažką būdingo tavo sričiai arba požiūriui.",

      why:
        "Trendas gali paskolinti formatą. Bet turinio mintis vis tiek turi priklausyti tau."
    }
  };


  const tabs = root.querySelector("#charmTabs");
  const compare = root.querySelector("#charmCompare");
  const why = root.querySelector("#charmWhy");


  function renderComparison(key) {
    const item = comparisons[key];

    compare.innerHTML =
      '<div class="compare-card">' +
        '<div class="compare-year">' + item.oldYear + "</div>" +
        '<div class="compare-type">' + item.oldType + "</div>" +
        '<div class="compare-copy">' + item.oldCopy + "</div>" +
      "</div>" +

      '<div class="compare-card">' +
        '<div class="compare-year">' + item.newYear + "</div>" +
        '<div class="compare-type">' + item.newType + "</div>" +
        '<div class="compare-copy">' + item.newCopy + "</div>" +
      "</div>";

    why.textContent = item.why;

    tabs.querySelectorAll("button").forEach(function (button) {
      button.classList.toggle(
        "selected",
        button.dataset.tab === key
      );
    });
  }


  tabs.addEventListener("click", function (event) {
    const button = event.target.closest("button[data-tab]");
    if (!button) return;

    renderComparison(button.dataset.tab);
  });

  renderComparison("before");


  /* =========================
     HOOK TEST
  ========================== */

  const hookFeedback = {
    a:
      "Silpnoji vieta — pradžia apie kūrėją. Naujas žmogus dar neturi priežasties laukti, ką nori papasakoti.",

    b:
      "Stiprus discovery įėjimas: iškart atpažįstama problema. Žmogus gali sustoti net pirmą kartą tave matydamas.",

    c:
      "Gali veikti kaip lengvas identity / vibe turinys, tačiau vienas pats beveik neparodo tavo profesinio skirtumo."
  };


  root.querySelector("#charmHooks").addEventListener("click", function (event) {
    const button = event.target.closest("[data-hook]");
    if (!button) return;

    root.querySelectorAll(".choice-card").forEach(function (item) {
      item.classList.remove("selected");
    });

    button.classList.add("selected");

    const feedback = root.querySelector("#charmHookFeedback");
    feedback.textContent = hookFeedback[button.dataset.hook];
    feedback.classList.add("show");
  });


  /* =========================
     PROOF LADDER
  ========================== */

  const proofText = {
    1:
      "Įrodo, kad gali padaryti vizualų pokytį.",

    2:
      "Jau leidžia potencialiai klientei atpažinti save konkrečioje situacijoje.",

    3:
      "Parodo tavo profesinį mąstymą — ne tik rankų darbą.",

    4:
      "Stipriausias įrodymas: parodai ne tik momentinį rezultatą, bet ir kas su juo nutiko realiame gyvenime."
  };


  root.querySelector("#charmProof").addEventListener("click", function (event) {
    const button = event.target.closest("[data-proof]");
    if (!button) return;

    root.querySelectorAll(".proof-btn").forEach(function (item) {
      item.classList.remove("selected");
    });

    button.classList.add("selected");

    root.querySelector("#charmProofOutput").textContent =
      proofText[button.dataset.proof];
  });


  /* =========================
     CONTENT CAPTURE
  ========================== */

  const captureInputs =
    Array.from(root.querySelectorAll("#charmCapture input"));

  captureInputs.forEach(function (input) {
    input.addEventListener("change", updateContentCount);
  });


  function updateContentCount() {
    let count = 0;

    captureInputs.forEach(function (input) {
      if (input.checked) {
        count += Number(input.value);
      }
    });

    root.querySelector("#charmContentCount").textContent = count;

    const message = root.querySelector("#charmContentMessage");

    if (count >= 8) {
      message.textContent =
        "Šitas vienas vizitas jau yra mini media paketas: discovery, expertise, proof ir follow-up medžiaga.";
    } else if (count >= 5) {
      message.textContent =
        "Jau matai daugiau nei portfolio. Iš vieno vizito gali sukurti kelias visiškai skirtingas turinio temas.";
    } else {
      message.textContent =
        "Didžioji dalis vertingiausio turinio įvyksta dar prieš AFTER nuotrauką.";
    }
  }


  /* =========================
     COMMENTS
  ========================== */

  const commentFeedback = {
    a:
      "Gerai santykiui su tuo žmogumi. Tačiau klausimą pamatys daugiausia tie, kurie jau skaito konkretų komentarų lauką.",

    b:
      "Stipru. Vieno žmogaus klausimą paverti atsakymu šimtams kitų, kurie gali turėti lygiai tą pačią problemą.",

    c:
      "Taip pat vertinga. Pasikartojantys komentarai yra nemokamas research — auditorija pati tau rašo būsimus hookus."
  };


  root.querySelector("#charmComments").addEventListener("click", function (event) {
    const button = event.target.closest("[data-comment]");
    if (!button) return;

    root.querySelectorAll("#charmComments button").forEach(function (item) {
      item.classList.remove("selected");
    });

    button.classList.add("selected");

    const feedback = root.querySelector("#charmCommentFeedback");

    feedback.textContent =
      commentFeedback[button.dataset.comment];

    feedback.classList.add("show");
  });


  /* =========================
     IDENTITY
  ========================== */

  const identityInputs =
    Array.from(root.querySelectorAll("#charmIdentity input"));

  identityInputs.forEach(function (input) {
    input.addEventListener("change", updateIdentity);
  });


  function updateIdentity() {
    const count = identityInputs.filter(function (input) {
      return input.checked;
    }).length;

    const message = root.querySelector("#charmIdentityMessage");

    if (count <= 1) {
      message.textContent =
        "Šiuo metu didžiąją tavo identiteto dalį greičiausiai neša vardas ir vizualas. Čia yra daug vietos augimui.";
    } else if (count <= 3) {
      message.textContent =
        "Jau yra už ko kabintis. Dabar svarbiausia tuos elementus kartoti pakankamai ilgai, kad juos pradėtų atpažinti kiti.";
    } else {
      message.textContent =
        "Tai jau panašu ne į atsitiktinį contentą, o į atpažįstamą media identitetą.";
    }
  }

})();
  } catch(e) { console.error(e); }
})();

})();
